import React, { useState } from 'react';
import API from '../api';
import { Users } from 'lucide-react';
import { msgErrore, fmtData, card, pulsante, errore, testoBlob } from './campagneComuni';

// "Esporta lead" della pagina Campagne: contatti da richiamare del periodo (tutti i canali e i tipi)
// in Excel, il file che prima dava docs/estrai_leads.py. Visibile solo con campagne.esporta_lead
// (lo controlla Campagne.js). Le date partono dal periodo del report ma sono indipendenti.
// "Escludi chi ha già aderito" (spenta a ogni apertura) usa i collegamenti lead → adesione del report:
// attribuzioneDal è il giorno da cui il report conta le adesioni (/campagne/filtri).

const DATA_OK = /^\d{4}-\d{2}-\d{2}$/;

export default function EsportaLead({ dal: dalReport, al: alReport, attribuzioneDal }) {
  const [aperto, setAperto] = useState(false);
  const [dal, setDal] = useState('');
  const [al, setAl] = useState('');
  const [senzaAderenti, setSenzaAderenti] = useState(false);
  const [scarico, setScarico] = useState(false);
  const [err, setErr] = useState(null);

  const apri = () => {
    if (!aperto) { setDal(dalReport); setAl(alReport); setSenzaAderenti(false); setErr(null); }
    setAperto(a => !a);
  };
  const date = DATA_OK.test(dal) && DATA_OK.test(al);
  const valido = date && dal <= al;

  const scarica = async () => {
    setScarico(true); setErr(null);
    try {
      const params = senzaAderenti ? { dal, al, escludi_aderenti: true } : { dal, al };
      const r = await API.get('/campagne/lead/excel', { params, responseType: 'blob' });
      const url = window.URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `CONTATTI_DA_RICHIAMARE_${senzaAderenti ? 'SENZA_ADERENTI_' : ''}${dal}_${al}.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      setAperto(false);
    } catch (e) {
      let detail = null;
      try { detail = JSON.parse(await testoBlob(e.response.data)).detail; } catch (_) { /* risposta non JSON */ }
      setErr(msgErrore(detail ? { response: { data: { detail } } } : e, 'Impossibile esportare i lead'));
    } finally {
      setScarico(false);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button style={pulsante(aperto)} onClick={apri} title="Contatti da richiamare del periodo, in Excel">
        <Users size={14} /> Esporta lead</button>
      {aperto && (
        <div style={{ ...card, position: 'absolute', right: 0, top: 38, zIndex: 10, width: 300,
          boxShadow: '0 4px 14px rgba(0,0,0,0.12)' }}>
          <div style={{ display: 'flex', gap: 10 }}>
            <label style={{ fontSize: 11, color: '#718096' }}>DAL<br />
              <input type="date" className="input-filtro" value={dal} onChange={e => setDal(e.target.value)} /></label>
            <label style={{ fontSize: 11, color: '#718096' }}>AL<br />
              <input type="date" className="input-filtro" value={al} onChange={e => setAl(e.target.value)} /></label>
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginTop: 10 }}>
            <input type="checkbox" checked={senzaAderenti} onChange={e => setSenzaAderenti(e.target.checked)} />
            Escludi chi ha già aderito</label>
          <div style={{ fontSize: 11, color: '#718096', marginLeft: 20 }}>
            Esclude chi risulta aderente nel report Campagne
            {attribuzioneDal ? ` (adesioni dal ${fmtData(attribuzioneDal)})` : ''}</div>
          {date && !valido && <div style={errore}>La data iniziale deve precedere quella finale.</div>}
          {err && <div style={errore}>{err}</div>}
          <div style={{ fontSize: 11, color: '#718096', margin: '8px 0' }}>
            Tutti i canali e i tipi, una riga per email (l'ultimo invio), senza i lead esclusi.</div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button style={pulsante(false)} onClick={() => setAperto(false)}>Annulla</button>
            <button style={pulsante(true, scarico || !valido)} disabled={scarico || !valido} onClick={scarica}>
              {scarico ? 'Preparazione…' : 'Scarica Excel'}</button>
          </div>
        </div>
      )}
    </div>
  );
}
